import React from 'react';

import { PublicPage } from 'api/website';
import { RecommendedJobsBlock } from 'cms/blocks/RecommendedJobs/RecommendedJobsBlock';
import { getIsContentFullWidthLayout } from 'cms/helpers';
import { useContentHomePageMeta } from 'cms/hooks';
import { AuthorCard } from 'components/Author/AuthorCard';
import { Box } from 'components/Box';

import { ContentPageTags } from './ContentPageTags';

type Props = {
  content: PublicPage;
};

export function ContentPageBelowBlocks({ content }: Props) {
  const { homePageUrl } = useContentHomePageMeta({ content });
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    (content.hasRecommendedJobs ||
      (content.tags && content.tags.length > 0) ||
      content.author) && (
      <>
        {content.tags && content.tags.length > 0 && (
          <Box mb={32}>
            <ContentPageTags
              homePageUrl={
                content.subsite.homePage && content.subsite.homePage.url
              }
              tags={content.tags}
            />
          </Box>
        )}

        {content.author && (
          <AuthorCard
            author={content.author}
            homePageUrl={homePageUrl}
            postedDate={content.postedDate}
            showDate={content.showDate}
            fullWidthLayout={fullWidthLayout}
          />
        )}

        {content.hasRecommendedJobs && (
          <RecommendedJobsBlock
            data={{
              headline: content.recommendedJobsHeadline,
              layout: 'REGULAR',
              jobFunction: undefined,
            }}
          />
        )}
      </>
    )
  );
}
